// public-chat.ts — zod schema for the public widget chat route (spec D11, M4 task-2).
// Unlike `playgroundChatSchema` (dashboard playground — sessionKey optional, falls back to
// a per-user synthetic key server-side), the widget ALWAYS generates a real session key
// client-side before it ever calls this endpoint (`apps/widget`'s `store.ts`, M4 task-3), so
// it's required here.
import { z } from 'zod';

export const publicChatSchema = z.object({
  message: z.string().min(1).max(2000),
  sessionKey: z.string().min(8).max(100),
});
